export const GREEN = '#006800';
export const RED = '#D62D0A';
export const BLUE = '#066FEF';
export const BROWN = '#B16201';
